import {
  Stack,
  Typography,
  Box,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Checkbox,
  useTheme,
  useMediaQuery,
} from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { useNavigate } from 'react-router-dom'
import Link from '@mui/material/Link'
import { useEffect, useRef, useState } from 'react'
import Paper from '@mui/material/Paper'
import AttachmentIcon from '@mui/icons-material/Attachment'

import CloseIcon from '@mui/icons-material/Close'
import TaskPng from 'Components/images/Task Icon big.png'
import DeletePng from 'Components/images/delete.png'
import ChecklistPng from 'Components/images/checklist.png'
import DocumentPng from 'Components/images/document.png'
import CommentPng from 'Components/images/comment.png'
import DescriptionPng from 'Components/images/description.png'
import AddPng from 'Components/images/add2.png'
import { Input } from 'Components/Input'
import Modal from '@mui/material/Modal'
import { useForm } from 'react-hook-form'
import ComboBox from 'Components/ComboBox'
import { convertToMuiDate } from 'utils/helpers'
import Avatar from '@mui/material/Avatar'
import { styled } from '@mui/material/styles'
import AddContact from '../../AddContact'
import Button from '@mui/material/Button'
import SaveIcon from '@mui/icons-material/Save'
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress'
import { makePostRequest, makeGetRequest, makePutRequest, makeDeleteRequest } from 'utils/api'
import urls from 'utils/urls'
import AddCheckList from '../../AddCheckList'
import CreateDocumentsForm from '../../CreateDocument'
import CustomButton from 'Components/CustomButton/CustomButton'
import { convertToUserDateFormate } from 'utils/helpers'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 400 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
  },
}))
const mstyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // width: 900,

  bgcolor: 'background.paper',
  boxShadow: 24,
  overflowY: 'auto',
  height: '90%',
  borderRadius: '10px',
  '::-webkit-scrollbar': {
    display: 'none',
  },
}
function AddModal(props) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const siteUser = useSelector((store) => store.user)

  const [selectedPriorite, setSelectedPriorite] = useState('')
  const [selectedCategory, setSelectedCategory] = useState('')
  const [statutText, setStatutText] = useState('')
  const [statutColor, setStatutColor] = useState('')
  const [showContactModel, setShowContactModel] = useState(false)
  const [id, setId] = useState(false)
  const [contacts, setContacts] = useState([])
  const [checkLists, setCheckLists] = useState([])
  const [comemntList, setComemntList] = useState([])
  const [checkListsPercentage, setCheckListsPercentage] = useState(0)
  const selectForm = useRef(null)
  const [inputValue, setInputValue] = useState({ id: null, Commentaires: '' })
  const [document, setDocument] = useState(false)
  const [category, setCategory] = useState([])
  const [checklistData, setChecklistData] = useState([])
  const [selected, setSelected] = useState([])
  let navigate = useNavigate()

  useEffect(() => {
    fetchCategory()
    setDocument(props.row.document)
  }, [])

  const fetchCategory = async () => {
    const url = '/api/time/get-category-dd'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.name}`, id: v.id })
      })
      setCategory([...filterTypes])
    }
  }
  const fetchComment = async () => {
    const url = urls.commentOperations + `?TaskId=${props.row.id}`
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      // setInputValue(data.results.length > 0 ? data.results[0] : '')
      setComemntList(data.results)
    }
  }

  useEffect(() => {
    // console.log(props)
    // setInputValue('')
    let selectedpriorite = priorite.filter((v) => v.label === props.row.Priorite)
    setSelectedPriorite(selectedpriorite ? selectedpriorite[0] : '')
    setValue('Priorite', selectedpriorite ? selectedpriorite[0] : '')
    setSelectedCategory(
      props.row.Categorie
        ? { label: `${props.row.categorie.name}`, id: props.row.categorie.id }
        : '',
    )
    setValue(
      'Categorie',
      props.row.Categorie
        ? { label: `${props.row.categorie.name}`, id: props.row.categorie.id }
        : '',
    )
    setValue('Descriptions', props.row.Descriptions ? props.row.Descriptions : '')
    setValue('Couts', props.row.Couts ? props.row.Couts : '')
    setValue('id', props.row.id ? props.row.id : '')
    setId(props.row.id ? props.row.id : false)
    setValue('DateLimite', props.row.DateLimite ? convertToMuiDate(props.row.DateLimite) : '')
    setValue(
      'start_date',
      props.row.event?.start_date ? convertToMuiDate(props.row.event.start_date) : '',
    )
    setChecklistData(props.row.CheckListId)
    setCheckLists(props.row.checklist)
    setContacts(props.row.contacts)
    setDocument(props.row.document)
    let total = props.row.checklist.length
    let done = 0
    props.row.checklist.map((v) => {
      if (v.Done) done++
      return ''
    })
    setCheckListsPercentage(done === 0 ? 0 : (done / total) * 100)
    let text = ''
    let color = ''
    if (props.row.Statut === 'Fait') {
      text = t('mesToDo.statusDone')
      color = 'green'
    } else if (props.row.Statut === 'En-retard') {
      text = t('mesToDo.statusLate')
      color = 'red'
    } else if (props.row.Statut === 'En-Cours') {
      text = t('mesToDo.statusInProgress')
      color = '#a37a00'
    } else {
      text = t('mesToDo.statusNotStarted')
      color = '#a37a00'
    }
    setStatutColor(color)
    setStatutText(text)
    fetchComment()
  }, [])

  const priorite = [
    { label: 'Important et urgent', id: 1 },
    { label: 'Important et non urgent', id: 2 },
    { label: 'Non-important et urgent', id: 3 },
    { label: 'Non-important et non-urgent', id: 4 },
  ]

  const { handleSubmit, control, setValue } = useForm({
    defaultValues: {},
  })
  const onSubmit = async (data) => {
    let payload = {}
    payload = {
      ...data,
      Priorite: data.Priorite?.label ? data.Priorite.label : '',
      DateLimite: data.DateLimite ? data.DateLimite : null,
      Categorie: data.Categorie.id,
    }
    const response = await makePutRequest(urls.taskOperations + `${data.id}/`, payload, {}, true)
    if (response.status === 200) {
      props.fetchOperations()
      props.handleModelClose()
    }
  }

  const addContacts = async (data) => {
    let payload = {}
    payload = {
      Contacts: data,
    }
    const response = await makePutRequest(urls.taskOperations + `${id}/`, payload, {}, true)
    if (response.status === 200) {
      setContacts(response.data.contacts)
    }
  }

  const submitComment = async (data1) => {
    let payload = {}
    payload = {
      Commentaires: inputValue.Commentaires,
      TaskId: props.row.id,
    }
    // const response = await makePutRequest(
    //   urls.commentOperations + `${inputValue.id}/`,
    //   payload,
    //   {},
    //   true,
    // )
    // if (response.status === 200) {
    // } else {
    const { data, status } = await makePostRequest(urls.commentOperations, payload, {}, true)
    if (status === 201) {
      setComemntList((pre) => [...pre, data])
      setInputValue({ id: '', Commentaires: '' })
    }
    // }
    // props.handleModelClose()
  }
  const addTasks = async (data) => {
    let payload = {}
    payload = {
      CheckListId: [...checklistData, data],
    }
    const response = await makePutRequest(urls.taskOperations + `${id}/`, payload, {}, true)
    if (response.status === 200) {
      setCheckLists(response.data.checklist)
      setChecklistData((pre) => [...pre, data])
    }
  }
  const addDocument = async (data) => {
    if (data) data.append('TaskMesToDo', id)
    let response = await makePostRequest(
      urls.crudDocumentsDetailsOperations,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      true,
    )
    if (response.status === 201) {
      setDocument([...document, response.data])
    }
  }
  const onSubTaskCheck = async (taskId) => {
    let filteredSubTask = checkLists.filter((v) => taskId === v.id)
    if (filteredSubTask.length > 0) {
      filteredSubTask = filteredSubTask[0]
      filteredSubTask.Done = !filteredSubTask.Done

      const response = await makePutRequest(
        urls.checkListOperations + `${taskId}/`,
        { Done: filteredSubTask.Done },
        {},
        true,
      )
      if (response.status === 204) {
        props.fetchOperations()
      }
    }

    let filtercheckLists = checkLists.filter((v) => taskId !== v.id)
    setCheckLists([...filtercheckLists, filteredSubTask].sort((a, b) => (a.id > b.id ? 1 : -1)))
    let total = checkLists?.length
    let done = 0
    checkLists.map((v) => {
      if (v.Done) done++
      return ''
    })
    setCheckListsPercentage(done === 0 ? 0 : (done / total) * 100)
  }
  const onSubTaskDel = async (taskId) => {
    const response = await makeDeleteRequest(urls.checkListOperations + `${taskId}/`, {}, true)
    if (response.status === 204) {
      let filtercheckLists = checkLists.filter((v) => taskId !== v.id)
      setChecklistData(checklistData.filter((e) => e !== taskId))
      setCheckLists(filtercheckLists)
      let total = filtercheckLists?.length
      let done = 0
      filtercheckLists.map((v) => {
        if (v.Done) done++
        return ''
      })
      setCheckListsPercentage(done === 0 ? 0 : (done / total) * 100)
      props.fetchOperations()
    }
  }
  const onTaskDel = async (taskId) => {
    const response = await makeDeleteRequest(urls.taskOperations + `${taskId}/`, {}, true)
    if (response.status === 204) {
      props.handleModelClose()
      props.fetchOperations()
    }
  }

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name)
    let newSelected = []
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      )
    }

    setSelected(newSelected)
  }
  const deleteBulkOperations = async () => {
    if (selected.length === 0) {
      alert(t('mesToDo.selectOperationAlert'))
    } else {
      const response = await makePostRequest(
        urls.deleteDocumentsBulkOperations,
        { selected: selected },
        {},
        true,
      )
      if (response.status === 200) {
        // fetchOperations(params.id, 20)
        setDocument(document.filter((e) => !selected.includes(e.id)))
        props.fetchOperations()
        setSelected([])
      }
    }
  }

  return (
    <>
      <Modal
        open={props.modelOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ '.ttdetal': { width: isMobile ? '90%' : '850px' } }}
      >
        <Box sx={mstyle} className="ttdetal">
          <Box>
            <form ref={selectForm} onSubmit={handleSubmit(onSubmit)}>
              <Box
                sx={{
                  textAlign: 'end',
                  padding: '5px 10px',
                }}
              >
                <Button type="submit">
                  <SaveIcon />
                </Button>
                <Button>
                  <img
                    src={DeletePng}
                    alt={''}
                    style={{
                      cursor: 'pointer',
                      padding: 0,
                      height: '20px',
                    }}
                    onClick={() => onTaskDel(id)}
                  />
                </Button>
                <Button>
                  <CloseIcon
                    sx={{
                      cursor: 'pointer',
                    }}
                    onClick={props.handleModelClose}
                  />
                </Button>
              </Box>
              <Box sx={{ padding: '0 15px' }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '5px 0',
                    marginTop: '-30px',
                  }}
                >
                  <Box
                    sx={{
                      padding: '0 5px',
                    }}
                  >
                    <img alt="" src={TaskPng} />
                  </Box>
                  <Box>
                    <Typography
                      id="modal-modal-title"
                      sx={{
                        color: 'black !important',
                        textAlign: 'left',
                      }}
                      variant="h7"
                      component="h4"
                    >
                      {props.row.Nom}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ marginLeft: '40px' }}>
                  {props.row.ListeId ? (
                    <Box
                      sx={{ color: 'unset', textDecoration: 'underline' }}
                      onClick={() => navigate('/todos/liste')}
                      component="a"
                    >
                      {t('mesToDo.inList')} {props.row.liste.Name}
                    </Box>
                  ) : props.row.ProjectId ? (
                    <Box
                      sx={{ color: 'unset', textDecoration: 'underline' }}
                      onClick={() => navigate('/todos/projects')}
                      component="a"
                    >
                      {t('mesToDo.inProject')} {props.row.project.Name}
                    </Box>
                  ) : (
                    ''
                  )}{' '}
                  ,
                  {props.row.DateModification
                    ? t('mesToDo.lastModification') + ' ' +
                      convertToUserDateFormate(siteUser.user, props.row.DateModification)
                    : ''}
                </Box>
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: { sm: '1fr 1fr 1fr 1fr' },
                    padding: '0 25px',
                  }}
                >
                  <ComboBox
                    handleAutoComplete={(e, j) => {
                      setValue('Categorie', j)
                      setSelectedCategory(j)
                    }}
                    label={t('mesToDo.fieldCategory')}
                    data={category}
                    name="Categorie"
                    control={control}
                    selectedValue={selectedCategory}
                  />
                  <ComboBox
                    handleAutoComplete={(e, j) => {
                      setValue('Priorite', j)
                      setSelectedPriorite(j)
                    }}
                    label="Priorite"
                    data={priorite}
                    name="Priorite"
                    control={control}
                    selectedValue={selectedPriorite}
                  />
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      size: 'small',
                      type: 'number',
                    }}
                    name="Couts"
                    label={t('mesToDo.fieldCosts')}
                  />
                  <Box>
                    <Box sx={{ fontWeight: 'bold' }}>{t('mesToDo.fieldStatus')}</Box>
                    <Box sx={{ color: statutColor, fontWeight: 'bold', fontSize: 'lager' }}>
                      {statutText}
                    </Box>
                  </Box>
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      size: 'small',
                      type: 'date',
                    }}
                    name="DateLimite"
                    label={t('mesToDo.fieldDueDate')}
                    InputLabelProps={{ shrink: true }}
                  />
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      size: 'small',
                      type: 'date',
                    }}
                    disabled
                    name="start_date"
                    label={t('mesToDo.fieldEvents')}
                    InputLabelProps={{ shrink: true }}
                  />
                  <Box>
                    <Box sx={{ fontWeight: 'bold' }}>{t('mesToDo.fieldContacts')}</Box>
                    <Box sx={{}}>
                      <Stack direction="row" spacing={2}>
                        {contacts &&
                          contacts.map((v) => <Avatar key={v.id} alt={v.Nom} src={v.Picture} />)}
                        <Button
                          onClick={() => {
                            setShowContactModel(true)
                          }}
                        >
                          <img alt="add" src={AddPng} />
                        </Button>
                      </Stack>
                    </Box>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '5px 0',
                  }}
                >
                  <Box
                    sx={{
                      padding: '0 5px',
                    }}
                  >
                    <img alt="" src={DescriptionPng} />
                  </Box>
                  <Box>
                    <Typography
                      id="modal-modal-title"
                      sx={{
                        color: 'black !important',
                        textAlign: 'left',
                      }}
                      variant="h7"
                      component="h4"
                    >
                      {t('mesToDo.description')}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: { sm: '1fr' },
                    padding: '0 10px',
                  }}
                >
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      size: 'small',
                      type: 'text',
                    }}
                    rows={4}
                    multiline
                    name="Descriptions"
                    label={t('mesToDo.description')}
                  />
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '5px 0',
                  }}
                >
                  <Box
                    sx={{
                      padding: '0 5px',
                    }}
                  >
                    <img alt="" src={ChecklistPng} />
                  </Box>
                  <Box>
                    <Typography
                      id="modal-modal-title"
                      sx={{
                        color: 'black !important',
                        textAlign: 'left',
                      }}
                      variant="h7"
                      component="h4"
                    >
                      {t('mesToDo.checklistLabel')}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      ':hover': {
                        background: '#f3f3f3',
                      },
                      marginLeft: 'auto',
                      cursor: 'pointer',
                      padding: '5px 10px',
                      border: '10px',
                    }}
                  >
                    <AddCheckList setCheckListIds={addTasks} />
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '5px 0',
                  }}
                >
                  <Box
                    sx={{
                      padding: '0 5px',
                    }}
                  >
                    {checkListsPercentage.toFixed(2)}%
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress variant="determinate" value={checkListsPercentage} />
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '5px 20px',
                    border: '1px solid #bdbdbd',
                    flexDirection: 'column',
                  }}
                >
                  {checkLists?.length > 0 ? (
                    checkLists.map((v) => (
                      <>
                        <Box
                          key={v.id}
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '-webkit-fill-available',
                            padding: '5px 15px',
                            ':hover': {
                              background: '#f3f3f3',
                            },
                          }}
                        >
                          <Box
                            sx={{
                              ':hover': {
                                background: '#f3f3f3',
                              },
                              '& input': {
                                width: 'unset',
                                minWidth: 'unset',
                              },
                            }}
                          >
                            <input
                              type="checkbox"
                              onClick={() => onSubTaskCheck(v.id)}
                              defaultChecked={v.Done}
                              name="Status"
                            />
                          </Box>
                          <Box sx={{ marginLeft: '15px' }}>{v.NomTask}</Box>
                          <Box sx={{ marginLeft: 'auto' }}>
                            <img
                              src={DeletePng}
                              alt={''}
                              style={{
                                cursor: 'pointer',
                                padding: 0,
                                height: '20px',
                              }}
                              onClick={() => onSubTaskDel(v.id)}
                            />
                          </Box>
                        </Box>
                      </>
                    ))
                  ) : (
                    <>{t('mesToDo.noSubTask')}</>
                  )}
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column-reverse' : 'row',

                    alignItems: 'center',
                    padding: '5px 0',
                  }}
                >
                  <Box
                    display={'flex'}
                    width={isMobile ? '100%' : 'unset'}
                    alignItems={'anchor-center'}
                  >
                    <Box
                      sx={{
                        padding: '0 5px',
                      }}
                    >
                      <img alt="" src={DocumentPng} />
                    </Box>
                    <Box>
                      <Typography
                        id="modal-modal-title"
                        sx={{
                          color: 'black !important',
                          textAlign: 'left',
                        }}
                        variant="h7"
                        component="h4"
                      >
                        {t('mesToDo.documentLabel')}({document?.length})
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      // ':hover': {
                      //   background: '#f3f3f3',
                      // },
                      marginLeft: 'auto',
                      cursor: 'pointer',
                      padding: '5px 10px',
                      border: '10px',
                    }}
                  >
                    <CreateDocumentsForm
                      setDocument={addDocument}
                      taskid={id}
                      modelName={t('mesToDo.addDocument')}
                    />
                    <CustomButton sx={{ color: 'black' }} onClick={deleteBulkOperations}>
                      {t('mesToDo.delete')}
                    </CustomButton>
                  </Box>
                </Box>
                <Box sx={{ color: 'white' }}>
                  <TableContainer>
                    <Table sx={{ marginTop: '23px' }} size="small" aria-label="simple table">
                      <TableBody>
                        {document &&
                          document.map((row, index) => (
                            <>
                              {row.Lien && (
                                <TableRow
                                  key={row.id}
                                  sx={{
                                    height: '80px',
                                    '&:last-child td, &:last-child th': { border: 0 },
                                  }}
                                >
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{ display: 'flex', alignItems: 'center' }}
                                  >
                                    <Checkbox
                                      onClick={(event) => handleClick(event, row.id)}
                                      color="primary"
                                      inputProps={{
                                        'aria-labelledby': index,
                                      }}
                                    />
                                    <AttachmentIcon
                                      sx={{ padding: '0px 13px', fontSize: '45px' }}
                                    />
                                    <Box style={{ a: { color: 'blue !important' } }}>
                                      <Link style={{ color: 'blue !important' }} href={row.Lien}>
                                        {row.Lien.split('/').pop()}
                                      </Link>
                                      <br />
                                      {t('mesToDo.loadedOn')}{' '}
                                      {convertToUserDateFormate(siteUser.user, row.Datedimport)} -
                                      {t('mesToDo.fileSize')}: {row.FileSize} Mio
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              )}
                            </>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '5px 0',
                  }}
                >
                  <Box
                    sx={{
                      padding: '0 5px',
                    }}
                  >
                    <img alt="" src={CommentPng} />
                  </Box>
                  <Box>
                    <Typography
                      id="modal-modal-title"
                      sx={{
                        color: 'black !important',
                        textAlign: 'left',
                      }}
                      variant="h7"
                      component="h4"
                    >
                      {t('mesToDo.comments')}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ color: 'white' }}>
                  <TableContainer>
                    <Table sx={{ marginTop: '4px' }} size="small" aria-label="simple table">
                      <TableBody>
                        {comemntList.map((row) => (
                          <TableRow
                            key={row.id}
                            sx={{
                              height: '40px',
                              '&:last-child td, &:last-child th': { border: 0 },
                            }}
                          >
                            <TableCell
                              component="th"
                              scope="row"
                              sx={{ display: 'flex', alignItems: 'center' }}
                            >
                              {/* <AttachmentIcon sx={{ padding: '0px 13px', fontSize: '45px' }} /> */}
                              {row.user && row.comment_user.img ? (
                                <Avatar alt={'Life'} src={row.comment_user.img_url} />
                              ) : (
                                <Avatar alt={'Life'} src={''} />
                              )}
                              <Box sx={{ ml: 2 }}>
                                <Box component={'span'} sx={{ color: '#1779cd' }}>
                                  {row.user && row.comment_user.prenom}{' '}
                                  {row.user && row.comment_user.nom}
                                </Box>
                                <br />
                                {row.Commentaires}
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: { sm: '0.5fr 10fr' },
                    padding: '0 10px',
                    ml: 1,
                  }}
                >
                  {props.row.User?.img ? (
                    <Avatar alt={'Life'} src={props.row.User.img_url} />
                  ) : (
                    <Avatar alt={'Life'} src={''} />
                  )}
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      size: 'small',
                      type: 'text',
                    }}
                    rows={4}
                    multiline
                    name="comment"
                    label={t('mesToDo.commentField')}
                    value={inputValue.Commentaires}
                    onChange={(e) => {
                      setInputValue({ ...inputValue, Commentaires: e.target.value })
                    }}
                  />
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                  <Button onClick={submitComment}>{t('mesToDo.validate')}</Button>
                </Box>
              </Box>
            </form>
          </Box>
        </Box>
      </Modal>
      {showContactModel && (
        <AddContact checkListContacts={addContacts} setShowContactModel={setShowContactModel} />
      )}
    </>
  )
}

function ListOperations({
  fetchOperations,
  operations,
  setSelectedRows,
  projectTaskId,
  projectTaskName,
  listeTaskId,
  listeTaskName,
}) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const siteUser = useSelector((store) => store.user)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [modifiedColumns, setModifiedColumns] = useState([])

  let navigate = useNavigate()
  const [modelOpen, setModelOpen] = useState(false)
  const [rowData, setRowData] = useState([])
  const handleModelOpen = () => setModelOpen(true)
  const handleModelClose = () => {
    setModelOpen(false)
    fetchOperations()
  }
  const [rows, setRows] = useState(20)
  const [page, setPage] = useState(0)
  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    let url = `&limit=${newPageSize}&offset=${page}`
    fetchOperations(url)
  }
  const handlePageChange = (newPage) => {
    setPage(newPage * rows)
    let url = `&limit=${rows}&offset=${newPage * rows}`
    fetchOperations(url)
  }

  useEffect(() => {
    if (isMobile) {
      setModifiedColumns([
        {
          field: 'Nom',
          headerName: t('mesToDo.colName'),
          width: 210,
          // valueGetter: (params) => `${params.row.Nom?.Nom || params.row.IBAN}`,
          renderCell: (params) => {
            let done = 0
            let checklist = params.row.checklist
            checklist.map((v) => {
              if (v.Done) done++
              return ''
            })
            let text = done + '/' + checklist.length
            return (
              <Box py={2} mt={1}>
                <Box fontWeight={600}>{params.row.Nom?.Nom}</Box>
                <Box>
                  <Box component={'span'}>{t('mesToDo.fieldCategory')}:</Box>{' '}
                  <Box component={'span'} fontWeight={600}>
                    {params.row.categorie?.name}
                  </Box>
                </Box>
                <Box>
                  <Box component={'span'}>{t('mesToDo.checklistLabel')}:</Box>{' '}
                  <Box component={'span'} fontWeight={600}>
                    {text}
                  </Box>
                </Box>
                <Box>
                  <Box component={'span'}>{t('mesToDo.fieldDueDate')}:</Box>{' '}
                  <Box component={'span'} fontWeight={600}>
                    {convertToUserDateFormate(siteUser.user, params.row.DateLimite)}
                  </Box>
                </Box>
              </Box>
            )
          },
        },
        {
          field: 'Statut',
          headerName: t('mesToDo.fieldStatus'),
          width: 130,
          type: 'number',
          renderCell: (params) => {
            let text = ''
            let color = ''
            if (params.row.Statut === 'Fait') {
              text = t('mesToDo.statusDone')
              color = 'green'
            } else if (params.row.Statut === 'En-retard') {
              text = t('mesToDo.statusLate')
              color = 'red'
            } else if (params.row.Statut === 'En-Cours') {
              text = t('mesToDo.statusInProgress')
              color = '#a37a00'
            } else {
              text = t('mesToDo.statusNotStarted')
              color = '#a37a00'
            }
            return (
              <Box
                sx={{
                  fontWeight: 600,
                  color: color,
                  width: '-webkit-fill-available',
                  textAlign: 'center',
                }}
              >
                {text}
              </Box>
            )
          },
        },
      ])
    } else {
      setModifiedColumns(columns)
    }
  }, [isMobile])
  const columns = [
    {
      field: 'Nom',
      headerName: t('mesToDo.colName'),
      width: 250,
      editable: false,
      renderCell: (params) => params.row.Nom,
    },
    {
      field: 'Categorie',
      headerName: t('mesToDo.fieldCategory'),
      width: 110,
      editable: false,
      valueGetter: (params) => `${params.row.categorie?.name}`,
    },
    {
      field: 'CheckListId',
      headerName: t('mesToDo.checklistLabel'),
      width: 80,
      editable: false,
      renderCell: (params) => {
        let done = 0
        let checklist = params.row.checklist
        checklist.map((v) => {
          if (v.Done) done++
          return ''
        })
        let text = done + '/' + checklist.length
        return <Box>{text}</Box>
      },
    },
    {
      field: 'DateLimite',
      headerName: t('mesToDo.fieldDueDate'),
      width: 100,
      editable: false,
      valueGetter: (params) => convertToUserDateFormate(siteUser.user, params.row.DateLimite),
    },
    {
      field: 'Evenements',
      headerName: t('mesToDo.fieldEvents'),
      width: 100,
      editable: false,
      renderCell: (params) => {
        let event = params.row.event
        return <div onClick={() => navigate('/MonCalendrier')}>{event.start_date}</div>
      },
    },
    {
      field: 'Contacts',
      headerName: t('mesToDo.fieldContacts'),
      width: 120,
      editable: false,
      renderCell: (params) => {
        let nom = []
        let contacts = params.row.contacts
        contacts.map((v) => {
          if (v.Nom) nom.push(v.Nom)
          return ''
        })
        let text = nom.join(',')
        return <Box>{text}</Box>
      },
    },
    {
      field: 'Statut',
      headerName: t('mesToDo.fieldStatus'),
      width: 110,
      editable: false,
      renderCell: (params) => {
        let text = ''
        let color = ''
        if (params.row.Statut === 'Fait') {
          text = t('mesToDo.statusDone')
          color = 'green'
        } else if (params.row.Statut === 'En-retard') {
          text = t('mesToDo.statusLate')
          color = 'red'
        } else if (params.row.Statut === 'En-Cours') {
          text = t('mesToDo.statusInProgress')
          color = '#a37a00'
        } else {
          text = t('mesToDo.statusNotStarted')
          color = '#a37a00'
        }
        return (
          <Box sx={{ color: color, width: '-webkit-fill-available', textAlign: 'center' }}>
            {text}
          </Box>
        )
      },
    },
  ]

  return (
    <div
      style={{
        height: 750,
        width: '100% ',
        background: 'white',
        borderRadius: '5px',
        paddingBottom: 54,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          flex: '1 1 100%',
          id: 'tableTitle',
          fontWeight: 600,
          padding: '10px',
          component: 'div',
        }}
      >
        {projectTaskId
          ? t('mesToDo.projectLabel') + ' (' + projectTaskName + ')'
          : listeTaskId
          ? t('mesToDo.listLabel') + ' (' + listeTaskName + ')'
          : ''}{' '}
        {t('mesToDo.tasksTitle', { count: operations.count })}
      </Typography>
      <DataGrid
        sx={{
          '.MuiDataGrid-footerContainer': { background: 'aliceblue' },
          '.MuiTablePagination-toolbar': { alignItems: 'baseline' },
        }}
        rows={operations.results ? operations.results : []}
        columns={modifiedColumns}
        pageSize={rows}
        getRowHeight={() => (isMobile ? 'auto' : 50)}
        rowCount={operations.count ? operations.count : 0}
        onPageSizeChange={handleRowsChange}
        onPageChange={handlePageChange}
        rowsPerPageOptions={[10, 20, 40, 80, 100]}
        pagination
        onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        paginationMode="server"
        checkboxSelection
        disableSelectionOnClick
        onRowClick={(e) => {
          setRowData(e.row)
          handleModelOpen()
        }}
      />
      {modelOpen && (
        <AddModal
          modelOpen={true}
          handleModelClose={handleModelClose}
          row={rowData}
          fetchOperations={fetchOperations}
        />
      )}
    </div>
  )
}
export default ListOperations
